import {
  IonButton,
  IonIcon,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonSearchbar,
  IonThumbnail,
} from "@ionic/react";
import React, { useCallback, useEffect, useState } from "react";

import { navigate } from "ionicons/icons";

import { Location } from "@/modules/shared/shared.types";

import { useLocationsHelpers } from "@/modules/locations/hooks";

type Props = {};

// Mock data for UI, will be removed later after fetching data
const mockLocationData: Location[] = [
  {
    id: "1",
    description: "מקלט 1",
    coords: {
      longt: 0,
      lat: 0,
      hash: "",
    },
    imagesUrls: ["image1.jpg", "image2.jpg"],
    distance: 0.0,
  },
  {
    id: "2",
    description: "מקלט 2",
    coords: {
      longt: 0,
      lat: 0,
      hash: "",
    },
    imagesUrls: ["image3.jpg"],
    distance: 0.0,
  },
  {
    id: "3",
    description: "מקלט 3",
    coords: {
      longt: 0,
      lat: 0,
      hash: "",
    },
    imagesUrls: [],
    distance: 0.0,
  },
  {
    id: "4",
    description: "מקלט 4",
    coords: {
      longt: 0,
      lat: 0,
      hash: "",
    },
    imagesUrls: ["image4.jpg"],
    distance: 0.0,
  },
];

export function LocationList(props: Props) {
  const [locationList, setLocationList] = useState<Location[]>(mockLocationData);
  const [viewList, setViewList] = useState<Location[]>(mockLocationData);

  // const { getNearbyShulters } = useLocationsHelpers();
  // useEffect(() => {
  //   getNearbyShulters();
  // }, []);

  const onListSearch = useCallback(
    (val: string | null | undefined) => {
      const searchTerm = val?.trim().toLowerCase() ?? "";

      if (searchTerm) {
        const filteredList = locationList.filter((location) =>
          location.description.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setViewList(filteredList);
      } else {
        setViewList(locationList);
      }
    },
    [locationList]
  );

  return (
    <>
      <IonSearchbar
        onIonInput={(e) => onListSearch(e.target.value)}
        placeholder="חיפוש"
      ></IonSearchbar>

      <IonList lines="full">
        {viewList.map((location, index) => (
          <IonItem key={location.id || index}>
            <IonThumbnail slot="start">
              <IonImg
                src={
                  location.imagesUrls?.[0] ??
                  "/location-placeholder.png"
                }
                alt={location.description}
                className="rounded-lg object-cover"
              />
            </IonThumbnail>
            <IonLabel>{location.description}</IonLabel>
            <IonButton slot="end" fill="clear">
              <IonIcon icon={navigate} />
            </IonButton>
          </IonItem>
        ))}
      </IonList>
    </>
  );
}
